import {Divider} from '@ds/components';
import RegistrationOverviewStep from 'modules/VendorRegisterOverview/components/RegistrationOverviewSteps/components/RegistrationOverviewStep/RegistrationOverviewStep';

type RegistrationOverviewStepsProps = {
  registrationStep?: string;
  isApprovedByAdmin: boolean;
};

const RegistrationOverviewSteps: React.FC<RegistrationOverviewStepsProps> = ({
  registrationStep,
  isApprovedByAdmin
}) => {
  const isPreApprovalDisabled =
    (registrationStep === 'NotRegistered' || !isApprovedByAdmin) &&
    registrationStep !== 'WaitingForAdminApprove';

  const steps = [
    {
      title: 'مشخصات کاربری',
      disabled: registrationStep === 'NotRegistered',
      variant: isApprovedByAdmin ? ('success' as const) : ('primary' as const)
    },
    {
      title: 'مدرک شناسایی',
      disabled: isPreApprovalDisabled,
      variant: isApprovedByAdmin ? ('success' as const) : ('primary' as const)
    },
    {
      title: 'اطلاعات فروشگاه',
      disabled: isPreApprovalDisabled,
      variant: isApprovedByAdmin ? ('success' as const) : ('primary' as const)
    },
    {
      title: 'اطلاعات حساب بانکی',
      disabled: isPreApprovalDisabled,
      variant: isApprovedByAdmin ? ('success' as const) : ('primary' as const)
    },
    {
      title: 'احراز هویت',
      disabled: registrationStep === 'NotRegistered' || !isApprovedByAdmin,
      variant: 'primary' as const
    },
    {
      title: 'آپلود تصویر امضا',
      disabled: true,
      variant: 'primary' as const
    },
    {
      title: 'اتمام ثبت نام',
      disabled: true,
      variant: 'primary' as const
    }
  ];

  return (
    <div className="flex flex-col px-4 py-2.5">
      {steps.map((step, index) => (
        <div key={step.title}>
          <RegistrationOverviewStep
            stepNumber={index + 1}
            title={step.title}
            disabled={step.disabled}
            variant={step.variant}
          />
          {index < steps.length - 1 ? (
            <Divider
              type="vertical"
              size={1}
              height={26}
              className="ms-3.75! me-0! w-px! border-l border-dashed border-gray-06 bg-transparent!"
            />
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default RegistrationOverviewSteps;
